import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Divider } from 'ui/divider';

import { body2, caption, colors, largeShadow, spacing, subtitle2, fontWeights } from 'ui/theme';

export const StyledDataContextInnerBody = styled.div`
  ${body2}
  color: ${colors.textSecondary};
  text-align: left;
`;

export const StyledDataContextInnerCountText = styled.span`
  ${body2}
  color: ${colors.textPrimary};
  font-weight: ${fontWeights.bold};
`;

export const StyledSmallDivider = styled(Divider)`
  margin-top: ${spacing.threeQuarter};
  margin-bottom: ${spacing.threeQuarter};
`;

export const StyledDataContextContent = styled.div`
  ${largeShadow}
  height: 100%;
  width: ${pxToRem(236)};
  background: ${colors.white};
  border-color: ${colors.grey5};
  border-radius: ${spacing.quarter};
  padding: ${spacing.threeQuarter};
  margin-left: ${spacing.quarter};
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
`;

export const StyledDataContextTitle = styled.div`
  ${subtitle2};
  text-align: left;
  overflow-wrap: break-word;
`;

export const StyledDataContextCaption = styled.div`
  ${caption}
  color: ${colors.textSecondary};
  display: flex;
`;

export const StyledDataContextInnerWrapper = styled.div`
  background: ${colors.grey1};
  border-radius: ${spacing.threeEights};
  padding: ${spacing.threeQuarter};
`;

export const StyledSecondaryContentText = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;

export const StyledDataContextDisabledCaption = styled.div`
  ${caption}
  color: ${colors.textDisabled};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  padding-bottom: ${spacing.threeQuarter};
`;

export const StyledLastRefreshDays = styled.div`
  ${caption}

  color: ${colors.textPrimary};

  &[data-is-last-refresh-tooltip-enabled='true'] {
    text-decoration: underline;
    text-decoration-style: dotted;
  }
`;

export const StyledErrorLoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  ${caption}
  color: ${colors.textDisabled};
  gap: ${spacing.eighth};
  padding-top: ${spacing.base};
  padding-bottom: ${spacing.base};
  justify-content: center;
`;
